/**
 * useUIErrorDisplay Hook - Access UIErrorDisplay from context
 * Used within UIErrorDisplayProvider to get display methods
 */

import { useContext } from "react";
import { UIErrorDisplayContext } from "./UIErrorDisplayProvider";

export const useUIErrorDisplay = () => {
  const context = useContext(UIErrorDisplayContext);

  if (!context) {
    throw new Error(
      "useUIErrorDisplay must be used within UIErrorDisplayProvider",
    );
  }

  return context;
};
